<div *ngrxLet="viewModel$; let model;"
     class="flex items-center justify-between w-full max-w-full group main-container">

  <div class="flex">
    <app-column-sorting-button [columnName]="model.params?.displayName"
      [sortDirection]="model.sortDirection"
      [sortIndex]="model.sortIndex"
      [sortingDisabled]="!model.params?.enableSorting"
      (sortingChange)="onSortRequested($event, model.params)"/>

    @if (model.isToggleable) {
      <div class="h-6 w-6 flex items-center justify-center mt-[1px] mr-1
                  rounded-[50%] cursor-pointer
                  text-neutral-60 hover:bg-[#F5F5F5] hover:text-neutral-10
                  invisible group-hover:visible"
           (click)="onHideClick(model.params)">
        <mat-icon svgIcon="visibility_off_outline" class="h-5 w-5"></mat-icon>
      </div>
    }

    @if (model.params?.enableMenu) {
      <div class="filterMenu
                  h-6 w-6 flex items-center justify-center mt-[1px]
                  rounded-[50%] cursor-pointer
                  text-neutral-60 hover:bg-[#F5F5F5] hover:text-neutral-10
                  invisible group-hover:visible"
           (click)="onMenuClick(model.params)">
        <mat-icon svgIcon="menu" class="h-5 w-5"></mat-icon>
      </div>
    }

  </div>


  <div class="flex">

    @if (model.params?.hasDataSourceIcon) {
      <mat-icon
        class="dataSourceIcon"
        [ngClass]="model.dataSourceIconType"
        [matTooltip]="model.dataSourceTooltip"
        matTooltipPosition="below"
        [svgIcon]="model.dataSourceIconName">
      </mat-icon>
    }

    @if (model.params?.staticColumnNote) {
      <app-static-column-note
        [columnName]="model.params?.displayName"
        [columnNote]="model.params?.staticColumnNote"/>
    }

    <app-dynamic-column-note [columnID]="model.params?.column?.getId()"/>

  </div>

</div>